<mat-expansion-panel class="expansion-panel" [expanded]="expanded">
  <mat-expansion-panel-header class="panel-header" [collapsedHeight]="'32px'" [expandedHeight]="'32px'">
    <mat-panel-title class="header-title" [tooltip]="title" [showDelay]="1000" [zIndex]="10000">{{ title }}</mat-panel-title>
    <mat-panel-description class="header-description" [innerHTML]="description"></mat-panel-description>
  </mat-expansion-panel-header>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</mat-expansion-panel>
